import css from 'styled-jsx/css';

export default css`
  .header-home {
    padding: 55px 25px 25px;
    text-align: center;
  }

  .header-home h1 {
    font-size: 16px;
    line-height: 1.25;
    margin: 15px 25px 5px;
  }

  .header-home h2 {
    font-size: 14px;
    opacity: 0.5;
    line-height: 1.25;
    margin: 0 25px;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Header/HeaderHome/styles.js